
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import vuescroll from 'vuescroll';
import 'vuescroll/dist/vuescroll.css';
import Helpers from '../Helpers';

@Component({ components: { vuescroll } })
export default class ScrollableMixin extends Vue {
  private vueScrollOptions = Helpers.GetVueScrollOptions();

  @Watch('offer')
  public scrollToTop() {
    (this.$refs['vs'] as vuescroll).scrollTo({ x: 0, y: 0 });
  }
}
